/**
 * 文件转base64
 * @param  file 文件流
 * @param  callback 回调函数
 */
export function fileByBase64(file, callback) {
  let reader = new FileReader();
  // 传入一个参数对象即可得到基于该参数对象的文本内容
  reader.readAsDataURL(file);
  reader.onload = function (e) {
    // target.result 该属性表示目标对象的DataURL
    callback(e.target?.result);
  };
}

/**
 * Base64转成canvas
 * @param  base64
 */
export async function imgToCanvas(base64) {
  // 创建img元素
  const img = document.createElement("img");
  img.setAttribute("src", base64);
  await new Promise((resolve) => (img.onload = resolve));
  // 创建canvas DOM元素，并设置其宽高和图片一样
  const canvas = document.createElement("canvas");
  console.log(img.height);
  console.log(img.width);
  canvas.width = img.width;
  canvas.height = img.height;
  // 坐标(0,0) 表示从此处开始绘制，相当于偏移。
  canvas.getContext("2d")?.drawImage(img, 0, 0);
  return canvas;
}

/**
 * canvas添加水印
 * @param  canvas 对象
 * @param text 水印文字
 */
export function addWatermark(canvas, bottomText, topText) {
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#aaa";
  ctx.textBaseline = "end";
  ctx.font = ctx.canvas.width / 20 + "px Arial";
  ctx.textAlign = "center";
  ctx.textBaseline = "end";
  // ctx.rotate(45);
  // ctx.rotate((90 * Math.PI) / 180);
  ctx.fillText(
    topText,
    canvas.width / 2,
    canvas.height - 300 - canvas.height / 3
  );
  ctx.fillText(bottomText, canvas.width / 2, canvas.height - canvas.height / 3);
  return canvas;
}

/**
 * canvas转成img
 * @param {canvas对象} canvas
 */
export function convasToImg(canvas, type) {
  // 新建Image对象，可以理解为DOM
  let image = new Image();
  // canvas.toDataURL 返回的是一串Base64编码的URL
  // 指定格式 PNG
  image.src = canvas.toDataURL(type);
  return image;
}
/**
 * @param urlData  base64
 * @param fileName 文件名称
 * @returns {File}
 */
export function base64ToFile(urlData, fileName) {
  let arr = urlData.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  let bytes = atob(arr[1]); // 解码base64
  let n = bytes.length;
  let ia = new Uint8Array(n);
  while (n--) {
    ia[n] = bytes.charCodeAt(n);
  }
  return new File([ia], fileName, { type: mime });
}
